import { React, useState } from "react";
import githubIcon from "./images/github.svg";
import Aos from "aos";
import "aos/dist/aos.css";
import { useContext } from "react";
import { useEffect } from "react";
import { defaultLang } from "./LanguageContext";
import truncateString from "./util/truncateString";

import { motion, AnimatePresence } from "framer-motion";

// import barberShopCover from "./images/barshop-cover.png";
// import adviceGeneratorThumbnail from "./images/advice-generator.png";
// import oceanSaveCover from "./images/oceansave-cover.png";
// import giardinoCover from "./images/Gardino-cover.png";
// import lightstudioCover from "./images/lightstudio-cover.png";
// import loopstudiocover from "./images/loppsstudiocover.png";
// import introcover from "./images/intro-sectionperview.png";
// import ratingcover from "./images/ratingcover.png";
// import blogrcover from "./images/blogrcover.png";
// import giocciacover from "./images/giocciacover.png";
// import discordcover from "./images/discordcover.png";
// import colorpickerimg from "./images/colorpicker.png";
// import herothemeimg from "./images/herotheme.png";
// import moviefinderimg from "./images/moviefinder.png";
// import photosearcherimg from "./images/photosearcher.png";
// import pomodorotimerimg from "./images/pomodorotimer.png";

const adviceGeneratorThumbnail = "https://iili.io/HJUwQrF.png";
const barberShopCover = "https://iili.io/HJg3PZg.png";
const oceanSaveCover = "https://iili.io/HJgYLVj.png";
const blogrcover = "https://iili.io/HJgufl1.jpg";
const colorpickerimg = "https://iili.io/HJglCtn.png";
const discordcover = "https://iili.io/HJgEUUx.png";
const giardinoCover = "https://iili.io/HJgVkiX.png";
const giocciacover = "https://iili.io/HJgjn5b.png";
const herothemeimg = "https://iili.io/HJgvdzb.png";
const lightstudioCover = "https://iili.io/HJgP75l.jpg";
const loopstudiocover = "https://iili.io/HJgZZUg.png";
const moviefinderimg = "https://iili.io/HJgpNat.png";
const photosearcherimg = "https://iili.io/HJrHXMx.png";
const ratingcover = "https://iili.io/HJr3SJp.png";
const pomodorotimerimg = "https://iili.io/HJrf5bI.png";
const weatherconditionimg = "https://iili.io/HfFK1Ul.png";
const movieappimg = "https://iili.io/HWJhOGV.png";
const onlinestepsimg =
  "https://github.com/d2ni3l/Project-7/raw/main/project-7/demo-img.png";

const spotifyimg =
  "https://i.ibb.co/zrbNLZf/screencapture-spotify-clonez-netlify-app-2023-06-11-18-39-34.png";
const pastAuctionimg =
  "https://i.ibb.co/hXMgMx7/screencapture-pastauction-trcc-vercel-app-2023-08-29-08-16-05.png";
const airbnbimg = "https://i.ibb.co/K7L088w/airbnbimage.png";
const dropIn = {
  hidden: {
    y: "-100vh",
    opacity: 0,
  },
  visible: {
    opacity: 1,
    y: "0",
    transition: {
      duration: 0.1,
      type: "spring",
      damping: 25,
      stiffness: 500,
    },
  },
  exit: {
    y: "100vh",
    opacity: 0,
  },
};

function BackdropModal({ handleClose, children }) {
  return (
    <motion.div
      onClick={handleClose}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      id='staticModal'
      data-modal-backdrop='static'
      tabindex='-1'
      aria-hidden='true'
      class='bg-[#000000b6]  flex justify-center fixed top-0 left-0 right-0 z-50  w-full p-4 modal-scrollbar  overflow-y-auto overflow-x-hidden md:inset-0 h-screen'>
      <div class='relative w-full h-[fit-content] p-8 max-w-2xl min-w-[360px] '>
        {children}
      </div>
    </motion.div>
  );
}

export default function Projects() {
  const { lang } = useContext(defaultLang);
  useEffect(() => {
    Aos.init({
      duration: 900,
    });
  }, []);

  const [barberShopModal, setbarberShopModal] = useState(false);
  const closeBarberShopModal = () => {
    setbarberShopModal(false);
  };
  const [PastAuctionModel, setPastAuctionModel] = useState(false);
  const closePastAuctionModel = () => {
    setPastAuctionModel(false);
  };

  const [adviceModal, setadviceModal] = useState(false);
  const closeAdviceModal = () => {
    setadviceModal(false);
  };

  const [oceanModal, setOceanModal] = useState(false);
  const closeOceanModal = () => {
    setOceanModal(false);
  };

  const [giardinoModal, setGiardinoModal] = useState(false);
  const closeGiardinoModal = () => {
    setGiardinoModal(false);
  };

  const [lightstudioModal, setLightstudioModal] = useState(false);
  const closeLightstudioModal = () => {
    setLightstudioModal(false);
  };

  const [loopstudioModal, setLoopstudioModal] = useState(false);
  const closeLoopstudioModal = () => {
    setLoopstudioModal(false);
  };

  const [blogrModal, setBlogrModal] = useState(false);
  const closeBlogrModal = () => {
    setBlogrModal(false);
  };
  const [giocciaModal, setGiocciaModal] = useState(false);
  const closeGiocciaModal = () => {
    setGiocciaModal(false);
  };

  const [discordModal, setDiscordModal] = useState(false);
  const closeDiscordModal = () => {
    setDiscordModal(false);
  };

  const [photosearcher, setphotosearcher] = useState(false);
  const closephotosearcher = () => {
    setphotosearcher(false);
  };

  const [pomodorotimer, setpomodorotimer] = useState(false);
  const closepomodorotimer = () => {
    setpomodorotimer(false);
  };

  const [weather, setweather] = useState(false);
  const closeweather = () => {
    setweather(false);
  };

  const [movieapp, setmovieapp] = useState(false);
  const closeMovieapp = () => {
    setmovieapp(false);
  };

  const [spotifyapp, setspotifyapp] = useState(false);
  const closeSpotifyapp = () => {
    setspotifyapp(false);
  };

  const [airbnbapp, setairbnbapp] = useState(false);

  const closeAirbnbapp = () => {
    setairbnbapp(false);
  };

  const [all, setAll] = useState(true);
  const [react, setReact] = useState(false);
  const [plain, setPlain] = useState(false);

  return (
    <>
      <section className='xl:10'>
        <h1 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-5xl pb-6 mt-28 font-bold tracking-wider'>
          {lang === "Eng" ? "Projects" : "Progetti"}
        </h1>

        <div className='w-[30px] h-[8px] bg-[#9499ff] rounded-[10px] mx-auto'></div>
        <h2 className='text-center text-[#E3E3E3] dark:text-[#1E1E1E]  text-xl mt-5 font-semibold tracking-wider'>
          {lang === "Eng" ? "Have a look!" : "Dai un'occhiata in giro!"}
        </h2>

        <div className='flex justify-center mt-9'>
          <ul className='flex gap-8 text-lg text-[#E3E3E3] dark:text-[#1E1E1E] '>
            <li
              onClick={() => {
                setAll(true);
                setPlain(false);
                setReact(false);
              }}
              className={`${
                all === true
                  ? `border-b-[4px] font-medium mb-4 tracking-widest border-[#9499ff]`
                  : `border-b-[4px] border-transparent`
              }`}>
              <button>{lang === "Eng" ? "All" : "Tutti"}</button>
            </li>
            <li
              onClick={() => {
                setReact(true);
                setAll(false);
                setPlain(false);
              }}
              className={`${
                react === true
                  ? `border-b-[4px] font-medium mb-4 tracking-widest border-[#9499ff]`
                  : `border-b-[4px] border-transparent`
              }`}>
              <button>React</button>
            </li>
            <li
              onClick={() => {
                setPlain(true);
                setReact(false);
                setAll(false);
              }}
              className={`${
                plain === true
                  ? `border-b-[4px] font-medium mb-4 tracking-widest border-[#9499ff]`
                  : `border-b-[4px] border-transparent`
              }`}>
              <button>{lang === "Eng" ? "Plain" : "Senza Framework"}</button>
            </li>
          </ul>
        </div>

        <div className='flex justify-center '>
          {all && (
            <div className='overflow-x-hidden no-scroll grow scale-div grid justify-center mt-5 mx-4 gap-14 pt-7 pb-12   md:grid-cols-2 md:gap-6 lg:mx-10  md:mx-20 lg:grid-cols-3  place-items-center max-w-6xl '>
              <div
                onClick={() => {
                  setairbnbapp(!airbnbapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div className='recent absolute py-1 px-3 bg-[#9499ff] bottom-4 text-white right-3 text-sm rounded-full'>
                  {lang === "Eng" ? " recent ✨" : "recente ✨"}
                </div>

                <div
                  style={{
                    backgroundImage: `url(${airbnbimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>
                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Airbnb clone
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `Airbnb is an online marketplace that connects people who
                    want to rent out their property.`
                      : `Airbnb è un mercato online che mette in contatto persone che
                    vogliono affittare il loro immobile.`}
                    <span className='text-lg'>🏠</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Next.js
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {airbnbapp && <AirbnbModal closeAirbnbapp={closeAirbnbapp} />}
              </AnimatePresence>

              <div
                onClick={() => {
                  setmovieapp(!movieapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${movieappimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Movie App
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `An application that allows you to view and save data of
                    movie and TV series`
                      : `Un'applicazione che ti consente di visualizzare e salvare i dati di
                    film e serie televisive.`}
                    <span className='text-lg'>🎬</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & Firebase
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {movieapp && <MovieappModal closeMovieapp={closeMovieapp} />}
              </AnimatePresence>

              <div
                onClick={() => {
                  setspotifyapp(!spotifyapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${spotifyimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Spotify App
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `An application that allows you view you favorite songs and
                    artists.`
                      : `Un'applicazione che ti consente di visualizzare le tue canzoni preferite e
                    artisti.`}
                    <span className='text-lg'>🎶</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & RapidAPI
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {spotifyapp && (
                  <SpotifyappModal closeSpotifyapp={closeSpotifyapp} />
                )}
              </AnimatePresence>

              <div
                onClick={() => {
                  setPastAuctionModel(!PastAuctionModel);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${pastAuctionimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Past Auction
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `A place for classic car enjoyer to learn about auctions.`
                      : `Un sito in cui gli appassionati di auto d'epoca possono conoscere le aste`}
                    <span className='text-lg'>🚘</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Next.js
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {PastAuctionModel && (
                  <PastAuctionModal
                    closePastAuctionModel={closePastAuctionModel}
                  />
                )}
              </AnimatePresence>

              <div
                onClick={() => {
                  setadviceModal(!adviceModal);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${adviceGeneratorThumbnail})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Advice Generator
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `An App that display advice on the click of a button`
                      : `Un'app che visualizza consigli con il semplice clic di un pulsante`}
                    <span className='text-lg'>💁</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {adviceModal && (
                  <AdviceModal closeAdviceModal={closeAdviceModal} />
                )}
              </AnimatePresence>

              <div
                onClick={() => {
                  setOceanModal(!oceanModal);
                }}
                data-aos='fade-up'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${oceanSaveCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Ocean Save
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {" "}
                    {lang === "Eng"
                      ? ` A demo Landing Page for a company`
                      : `Una landing page demo per un'azienda`}
                    <span className='text-lg'>🌊</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {oceanModal && <OceanModal closeOceanModal={closeOceanModal} />}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setLightstudioModal(!lightstudioModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${lightstudioCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Light Studio
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for an invented company that cleans the ocean`
                      : `Una landing page demo per un'azienda inventata che pulisce l'oceano`}
                    <span className='text-lg'>💡</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {lightstudioModal && (
                  <LightstudioModal
                    closeLightstudioModal={closeLightstudioModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                onClick={() => {
                  setBlogrModal(!blogrModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${blogrcover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Blogr
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for an invented company`
                      : `Una landing page demo per un'azienda inventata.`}
                    <span className='text-lg'>🏢</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {blogrModal && <BlogrModal closeBlogrModal={closeBlogrModal} />}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setGiocciaModal(!giocciaModal);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${giocciacover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Gioccia D'oro
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for a coffe shop`
                      : `Una landing page demo per un negozio di caffe.`}
                    <span className='text-lg'>☕</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {giocciaModal && (
                  <GiocciaModal closeGiocciaModal={closeGiocciaModal} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setphotosearcher(!photosearcher);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${photosearcherimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Photo Searcher
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? " An application that takes an input and generates a photo."
                      : "Un'applicazione che riceve un input e genera una foto."}{" "}
                    <span className='text-lg'>📸</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {photosearcher && (
                  <PhotoSearcher closephotosearcher={closephotosearcher} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                onClick={() => {
                  setpomodorotimer(!pomodorotimer);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${pomodorotimerimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Pomodoro Timer
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? " Pomodoro Timer is a customizable timer that helps you with the pomodoro technique "
                      : "Pomodoro Timer è un timer personalizzabile che ti aiuta la tecnica del pomodoro."}
                    <span className='text-lg'>⌚</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {pomodorotimer && (
                  <PomodoroTimer closepomodorotimer={closepomodorotimer} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setbarberShopModal(!barberShopModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${barberShopCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Barber Shop
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing page for a barbershop`
                      : `Una landing page demo per un barbiere.`}
                    <span className='text-lg'>💈</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {barberShopModal && (
                  <BarbershopModal
                    closeBarberShopModal={closeBarberShopModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setGiardinoModal(!giardinoModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 outline rounded-lg outline-[2px]  outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${giardinoCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Giardino
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {" "}
                    {lang === "Eng"
                      ? ` A demo landing page for a garden company`
                      : `Una landing page demo per un'azienda di giardinaggio.`}
                    <span className='text-lg'>🪴</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {giardinoModal && (
                  <GiardinoModal closeGiardinoModal={closeGiardinoModal} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setLoopstudioModal(!loopstudioModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${loopstudiocover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Loops Studio
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo landing page for invented company`
                      : `Una landing page demo per un'azienda inventato.`}
                    <span className='text-lg'>🏢</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {loopstudioModal && (
                  <LoopstudioModal
                    closeLoopstudioModal={closeLoopstudioModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setDiscordModal(!discordModal);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${discordcover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Discord Clone
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {" "}
                    {lang === "Eng"
                      ? ` The official discord website landing page clone with bootstrap`
                      : `Il clone ufficiale della pagina di destinazione del sito Web Discord con bootstrap`}
                    <span className='text-lg'>🟣</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Bootstrap
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {discordModal && (
                  <DiscordModal closeDiscordModal={closeDiscordModal} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setweather(!weather);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${weatherconditionimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Weather Conditon
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `Take in a city as an input and displays the current weather
                    condition `
                      : `Il sito Prende una città come input e visualizza il tempo attuale
                    condizione`}
                    <span className='text-lg'>☁️</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {weather && <WeatherModal closeweather={closeweather} />}
              </AnimatePresence>
            </div>
          )}

          {plain && (
            <div className='overflow-x-hidden no-scroll grow scale-div grid justify-center mt-5 mx-4 gap-14 pt-7 pb-12   md:grid-cols-2 md:gap-6 lg:mx-10  md:mx-20 lg:grid-cols-3  place-items-center max-w-6xl '>
              <div
                onClick={() => {
                  setOceanModal(!oceanModal);
                }}
                data-aos='fade-up'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${oceanSaveCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Ocean Save
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {" "}
                    {lang === "Eng"
                      ? ` A demo Landing Page for a company`
                      : `Una landing page demo per un'azienda`}
                    <span className='text-lg'>🌊</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {oceanModal && <OceanModal closeOceanModal={closeOceanModal} />}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setLightstudioModal(!lightstudioModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${lightstudioCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Light Studio
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for an invented company that cleans the ocean`
                      : `Una landing page demo per un'azienda inventata che pulisce l'oceano`}
                    <span className='text-lg'>💡</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {lightstudioModal && (
                  <LightstudioModal
                    closeLightstudioModal={closeLightstudioModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                onClick={() => {
                  setBlogrModal(!blogrModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${blogrcover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Blogr
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for an invented company`
                      : `Una landing page demo per un'azienda inventata.`}
                    <span className='text-lg'>🏢</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {blogrModal && <BlogrModal closeBlogrModal={closeBlogrModal} />}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setGiocciaModal(!giocciaModal);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${giocciacover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Gioccia D'oro
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing Page for a coffe shop`
                      : `Una landing page demo per un negozio di caffe.`}
                    <span className='text-lg'>☕</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTMl & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {giocciaModal && (
                  <GiocciaModal closeGiocciaModal={closeGiocciaModal} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setbarberShopModal(!barberShopModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${barberShopCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Barber Shop
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo Landing page for a barbershop`
                      : `Una landing page demo per un barbiere.`}
                    <span className='text-lg'>💈</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {barberShopModal && (
                  <BarbershopModal
                    closeBarberShopModal={closeBarberShopModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setGiardinoModal(!giardinoModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 outline rounded-lg outline-[2px]  outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${giardinoCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Giardino
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo landing page for a garden company`
                      : `Una landing page demo per un'azienda di giardinaggio.`}
                    <span className='text-lg'>🪴</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {giardinoModal && (
                  <GiardinoModal closeGiardinoModal={closeGiardinoModal} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setLoopstudioModal(!loopstudioModal);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${giardinoCover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Loops Studio
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` A demo landing page for invented company`
                      : `Una landing page demo per un'azienda inventato.`}
                    <span className='text-lg'>🏢</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      HTML & CSS
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {loopstudioModal && (
                  <LoopstudioModal
                    closeLoopstudioModal={closeLoopstudioModal}
                  />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setDiscordModal(!discordModal);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${discordcover})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Discord Clone
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` The official discord website landing page clone with bootstrap`
                      : `Il clone ufficiale della pagina di destinazione del sito Web Discord con bootstrap`}
                    <span className='text-lg'>🟣</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Bootstrap
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {" "}
                {discordModal && (
                  <DiscordModal closeDiscordModal={closeDiscordModal} />
                )}
              </AnimatePresence>
            </div>
          )}

          {react && (
            <div className='overflow-x-hidden no-scroll grow scale-div grid justify-center mt-5 mx-4 gap-14 pt-7 pb-12   md:grid-cols-2 md:gap-6 lg:mx-10  md:mx-20 lg:grid-cols-3  place-items-center max-w-6xl '>
              <div
                onClick={() => {
                  setairbnbapp(!airbnbapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div className='recent absolute py-1 px-3 bg-[#9499ff] bottom-4 text-white right-3 text-sm rounded-full'>
                  {lang === "Eng" ? " recent ✨" : "recente ✨"}
                </div>

                <div
                  style={{
                    backgroundImage: `url(${airbnbimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Airbnb clone
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `Airbnb is an online marketplace that connects people who
                    want to rent out their property.`
                      : `Airbnb è un mercato online che mette in contatto persone che
                    vogliono affittare il loro immobile.`}
                    <span className='text-lg'>🏠</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Next.js
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {airbnbapp && <AirbnbModal closeAirbnbapp={closeAirbnbapp} />}
              </AnimatePresence>

              <div
                onClick={() => {
                  setmovieapp(!movieapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${movieappimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Movie App
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `An application that allows you to view and save data of
                    movie and TV series`
                      : `Un'applicazione che ti consente di visualizzare e salvare i dati di
                    film e serie televisive.`}
                    <span className='text-lg'>🎬</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & Firebase
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {movieapp && <MovieappModal closeMovieapp={closeMovieapp} />}
              </AnimatePresence>

              <div
                onClick={() => {
                  setspotifyapp(!spotifyapp);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${spotifyimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Spotify App
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `An application that allows you view you favorite songs and
                    artists.`
                      : `Un'applicazione che ti consente di visualizzare le tue canzoni preferite e
                    artisti.`}
                    <span className='text-lg'>🎬</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & RapidAPI
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {spotifyapp && (
                  <SpotifyappModal closeSpotifyapp={closeSpotifyapp} />
                )}
              </AnimatePresence>

              <div
                onClick={() => {
                  setPastAuctionModel(!PastAuctionModel);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative z-10  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${pastAuctionimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Past Auction
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `A place for classic car enjoyer to learn about auctions`
                      : `Un luogo in cui gli appassionati di auto d'epoca possono conoscere le aste`}
                    <span className='text-lg'>🚘</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      Next.js
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {PastAuctionModel && (
                  <PastAuctionModal
                    closePastAuctionModel={closePastAuctionModel}
                  />
                )}
              </AnimatePresence>

              <div
                onClick={() => {
                  setadviceModal(!adviceModal);
                }}
                data-aos='fade-right'
                className='flex-col flex w-72 ml-1 relative  hoverprojects cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${adviceGeneratorThumbnail})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide  hover:underline'>
                    Advice Generator
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? ` An App that display advice on the click of a button`
                      : `Un'app che visualizza consigli con il semplice clic di un pulsante`}
                    <span className='text-lg'>💁</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>
              <AnimatePresence initial={false} onExitComplete={() => null}>
                {adviceModal && (
                  <AdviceModal closeAdviceModal={closeAdviceModal} />
                )}
              </AnimatePresence>
              <div
                data-aos='fade-left'
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'
                onClick={() => {
                  setphotosearcher(!photosearcher);
                }}>
                <div
                  style={{
                    backgroundImage: `url(${photosearcherimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Photo Searcher
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? " An application that takes an input and generates a photo."
                      : "Un'applicazione che riceve un input e genera una foto."}
                    <span className='text-lg'>📸</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {photosearcher && (
                  <PhotoSearcher closephotosearcher={closephotosearcher} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-right'
                onClick={() => {
                  setpomodorotimer(!pomodorotimer);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${pomodorotimerimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Pomodoro Timer
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? "An Pomodoro Timer Application, built with Vite, React, JavaScript, and CSS."
                      : "Un'applicazione Pomodoro Timer, costruita con Vite, React, JavaScript, e CSS."}{" "}
                    <span className='text-lg'>⌚</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {pomodorotimer && (
                  <PomodoroTimer closepomodorotimer={closepomodorotimer} />
                )}
              </AnimatePresence>

              <div
                data-aos='fade-left'
                onClick={() => {
                  setweather(!weather);
                }}
                className='flex-col flex w-72 ml-1   hoverprojects h-fit transition-all duration-500 cursor-pointer outline rounded-lg outline-[2px] outline-[#9499ff]'>
                <div
                  style={{
                    backgroundImage: `url(${weatherconditionimg})`,
                    backgroundSize: "100%",
                    backgroundPosition: "center center",
                  }}
                  className='rounded-t-lg h-[200px] w-auto'></div>

                <div className='flex flex-col bg-[#1e1e1e] -mt-1 rounded-b-lg gap-1 '>
                  <h2 className=' mt-4 relative text-[#E3E3E3] mx-4   font-extrabold  text-lg italic  duration-700 transition-all tracking-wide hover:text-[#767acc] hover:underline'>
                    Weather Conditon
                  </h2>
                  <p className='mx-4 text-white mt-2 text-xs leading-[1.3rem]  '>
                    {lang === "Eng"
                      ? `Take in a city as an input and displays the current weather
                    condition `
                      : `Il sito prende una città come input e visualizza il tempo attuale
                    condizione`}{" "}
                    <span className='text-lg'>☁️</span>.
                  </p>
                  <div className='mx-4 mt-6 pb-4'>
                    <button className=' uppercase text-[#E3E3E3]   font-light outline outline-[1px] outline-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
                      React & API
                    </button>
                  </div>
                </div>
              </div>

              <AnimatePresence initial={false} onExitComplete={() => null}>
                {weather && <WeatherModal closeweather={closeweather} />}
              </AnimatePresence>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

const PastAuctionModal = ({ closePastAuctionModel }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:tracking-wider'>Past Auction</h1>
          <button
            onClick={() => {
              closePastAuctionModel();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={pastAuctionimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap'>
            {/* onclick small info nbox  */}

            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TypeScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Npm libraries
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Next.js
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Swagger(API)
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              PostgreSQL
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "A place for classic car enjoyer to learn about auctions🚘."
              : "Un luogo dove gli appassionati di auto d'epoca possono conoscere le aste🚘."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://pastauction-trcc.vercel.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Pastauction/'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const PhotoSearcher = ({ closephotosearcher }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:tracking-wider'>Photo Searcher</h1>
          <button
            onClick={() => {
              closephotosearcher();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={photosearcherimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Vite
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " An application that takes an input and generates a photo, built with Vite, React, JavaScript, and CSS."
              : "Un'applicazione che riceve un input e genera una foto, creata con Vite, React, JavaScript e CSS."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://ph0tosearcher.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Project-2'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const PomodoroTimer = ({ closepomodorotimer }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Pomodoro Timer</h1>
          <button
            onClick={() => {
              closepomodorotimer();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={pomodorotimerimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Vite
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "An Pomodoro Timer Application, built with Vite, React, JavaScript, and CSS."
              : "Un'applicazione Pomodoro Timer, costruita con Vite, React, JavaScript, e CSS."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://pomodorotim3r.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Project-5'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const BarbershopModal = ({ closeBarberShopModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#f0eeee] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Barber Shop</h1>
          <button
            onClick={() => {
              closeBarberShopModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={barberShopCover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Bootstrap
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "I prototyped this website with Figma, then i developed it using HTML, Bootstrap, CSS and JavaScript"
              : "Ho prototipato questo sito web con Figma, poi l'ho sviluppato utilizzando HTML, Bootstrap, CSS e JavaScript"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://originalbarbershop.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/BarberShop'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const AdviceModal = ({ closeAdviceModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Advice Generator</h1>
          <button
            onClick={() => {
              closeAdviceModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={adviceGeneratorThumbnail}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex  gap-3 overflow-hidden flex-wrap ml-3'>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " A Web app that generates advice, developed using React and TailwindCSS"
              : "Un'app Web che genera consigli, sviluppata utilizzando React e TailwindCSS"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://advice-generator12.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/advice-generator'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const OceanModal = ({ closeOceanModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Ocean Save</h1>
          <button
            onClick={() => {
              closeOceanModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={oceanSaveCover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "A Front-end project made using plain HTML, CSS and JavaScript"
              : "Un progetto front-end realizzato utilizzando semplici HTML, CSS e JavaScript"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://oceansave.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/OceanSave'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='github icon' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const GiardinoModal = ({ closeGiardinoModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Giardino</h1>
          <button
            onClick={() => {
              closeGiardinoModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={giardinoCover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Bootstrap
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "A Front-end project made using plain HTML, CSS and JavaScript, prototyped with figma"
              : "Un progetto front-end realizzato utilizzando semplici HTML, CSS e JavaScript prototipato con figma"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://giardino.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Giardinoo'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const LightstudioModal = ({ closeLightstudioModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Light Studio</h1>
          <button
            onClick={() => {
              closeLightstudioModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={lightstudioCover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " Website project using mainly plain HTML, CSS and JavaScript"
              : "Progetto di sito web utilizzando principalmente HTML, CSS e JavaScript"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://lightstudio.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/lightstudios'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const LoopstudioModal = ({ closeLoopstudioModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative   pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Loop Studios</h1>
          <button
            onClick={() => {
              closeLoopstudioModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6  flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={loopstudiocover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Figma
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " A simple landing page I made using HTML, CSS and JavaScript."
              : "Una semplice landing page che ho realizzato utilizzando HTML, CSS e JavaScript."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://loopstudioss1.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Loopstudio'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const BlogrModal = ({ closeBlogrModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>BLogr</h1>
          <button
            onClick={() => {
              closeBlogrModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={blogrcover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " Website project using mainly plain HTML, CSS and JavaScript"
              : "Progetto di sito web utilizzando principalmente HTML, CSS e JavaScript"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://blogrlandingpage01.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/blogrLandingpage'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const GiocciaModal = ({ closeGiocciaModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Gioccia d'oro</h1>
          <button
            onClick={() => {
              closeGiocciaModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={giocciacover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info nbox  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " A Basic landing page made with plain HTML, CSS and JavaScript from some simple functionality"
              : "Una pagina di destinazione di base realizzata con semplici HTML, CSS e JavaScript da alcune semplici funzionalità"}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://giocciadoro.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const DiscordModal = ({ closeDiscordModal }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Discord Clone Website</h1>
          <button
            onClick={() => {
              closeDiscordModal();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={discordcover}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info box  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              BootStrap
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? ` I made a discord official website clone using HTML, CSS, Javascript,
              and Bootstrap (since this website is a clone of the official discord
              website, chrome may flag it as a deceptive website so to visit it...
              click Details and then click Visit this unsafe site )`
              : `Ho creato un clone del sito ufficiale Discord utilizzando HTML, CSS, Javascript,
              e Bootstrap (poiché questo sito è un clone del discord ufficiale
              sito web, Chrome potrebbe contrassegnarlo come sito Web ingannevole, quindi per visitarlo...
              fare clic su Dettagli e quindi su Visita questo sito non sicuro )`}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://discloned.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/dixscord'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const WeatherModal = ({ closeweather }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Weather Condition</h1>
          <button
            onClick={() => {
              closeweather();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={weatherconditionimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info box  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              API
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "  A Web App that take a city as an input and then displays a few weather conditions."
              : "Una Web App che prende una città come input e poi ne visualizza alcune condizioni meteo."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://theweathercondition.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Project-6'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const MovieappModal = ({ closeMovieapp }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Movie App</h1>
          <button
            onClick={() => {
              closeMovieapp();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={movieappimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info box  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              API
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Firebase
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? " An application that allows you to view and save data of movie and TV series."
              : "Un'applicazione che ti consente di visualizzare e salvare dati di film e TV serie."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://movie-app-b765d.web.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/movie-app'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const SpotifyappModal = ({ closeSpotifyapp }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Spotify App</h1>
          <button
            onClick={() => {
              closeSpotifyapp();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={spotifyimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info box  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              HTML5
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              CSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TailwindCSS
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              API
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              JavaScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Rapid API
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? "An application that allows you view you favorite songs and artists."
              : "Un'applicazione che ti consente di visualizzare le tue canzoni e i tuoi artisti preferiti."}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://spotify-clonez.netlify.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/Spotify-Clone/'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};

const AirbnbModal = ({ closeAirbnbapp }) => {
  const { lang } = useContext(defaultLang);
  return (
    <BackdropModal>
      <motion.div
        onClick={(e) => {
          e.stopPropagation();
        }}
        variants={dropIn}
        initial='hidden'
        animate='visible'
        exit='exit'
        className='relative  pb-6 rounded-lg shadow bg-[#242424] dark:bg-[#E3E3E3] border-[2px] border-[#6368ca] '>
        <div className='flex justify-between   mx-4 sm:mx-8 relative text-xl items-center  pt-5 text-[#E3E3E3] dark:text-[#1E1E1E] '>
          <h1 className='font-bold sm:traking-wider'>Airbnb App</h1>
          <button
            onClick={() => {
              closeAirbnbapp();
            }}
            type='button'
            className=' text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
            data-modal-toggle='popup-modal'>
            <svg
              aria-hidden='true'
              className=' fill-[#E3E3E3] dark:fill-[#1E1E1E] w-6 h-6'
              viewBox='0 0 20 20'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                fillRule='evenodd'
                d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                clipRule='evenodd'></path>
            </svg>
            <span className='sr-only'>Close modal</span>
          </button>
        </div>

        <div class=' pt-3 pb-6 pr-6 pl-6 flex justify-center'>
          <div className=''>
            <img
              className='rounded-[0.199rem]  md:w-[690px] h-[auto] '
              src={airbnbimg}
              alt=''
            />
          </div>
        </div>

        <div className='tools  mx-6 pb-12'>
          <h2 className='text-[#E3E3E3] dark:text-[#1E1E1E]  pb-3 text-xl font-semibold'>
            {lang === "Eng" ? "Tool Used" : "Strumenti utilizzati"}
          </h2>
          <div className='flex gap-3 ml-3 overflow-hidden flex-wrap '>
            {/* onclick small info box  */}
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Next.js
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              TypeScript
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7] tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Npm LIbraries
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              React
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Prisma
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              MongoDB
            </button>
            <button className='text-[#E3E3E3] dark:text-[#1E1E1E]  font-light bg-[#9499ff] transition-all duration-500 hover:bg-[#51539cc7]  tracking-wide rounded-full py-[.18rem] px-2 text-[.8rem] italic '>
              Tailwindcss
            </button>
          </div>
        </div>

        <div className='project-desc text-[#E3E3E3] dark:text-[#1E1E1E]  mx-6 pb-8'>
          <h2 className=' pb-3 text-lg font-semibold'>
            {lang === "Eng"
              ? "Project description"
              : "Descrizione dell'progetto"}
          </h2>
          <p className='text-[.9rem] itali font-light '>
            {lang === "Eng"
              ? `Airbnb clone - Airbnb is an online marketplace that connects people
              who want to rent out their property with people who are looking for
              accommodations, typically for short stays.`
              : `Clone di Airbnb - Airbnb è un mercato online che mette in contatto le persone
              che vogliono affittare il proprio immobile a persone che cercano
              alloggi, in genere per soggiorni brevi.`}
          </p>
        </div>

        <div className='preview text-[#9499ff] mx-6 pb-8 border-b-[#9499ff] border-b-2'>
          <a
            href='https://airbbzclone.vercel.app/'
            rel='noreferrer'
            target='_blank'
            className='preview-link pb-3 text-lg font-semibold underline '>
            {lang === "Eng" ? "Preview Website" : "Sito in anteprima"}
          </a>
        </div>

        <div className='mx-6 mt-3 flex text-[#9499ff] justify-center items-center gap-3'>
          <a
            target='_blank'
            rel='noreferrer'
            className='text-sm hover:underline'
            href='https://github.com/d2ni3l/airbnb-clone'>
            {lang === "Eng" ? "Github repo" : "Codice su Github"}
          </a>
          <img src={githubIcon} className='w-6' alt='' />
        </div>
      </motion.div>
    </BackdropModal>
  );
};
